import locationsList from '../static-content/locale-menu.json';

export const cleanInternalUrl = to => {
  // Remove origin
  let url = to;
  if (url.includes('credera.com')) {
    url = url.split('credera.com')[1];
  }

  // Remove locale if it is included
  const localeList = locationsList.locations.map(locale => locale.url);
  for (const locale of localeList) {
    if (url.includes(locale + '/') || url.endsWith(locale)) {
      url = url.split(locale)[1];
    }
  }

  return url ? url : '';
};
